import {DSYS_RAIL_DEFAULT_WIDTH, type DsysRailSize} from 'components/DSYS/layoutConstants';
import {darkModeAtom} from 'hooks/useSetThemeWatcher';
import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

import {themePreferenceAtom} from './settings';

export * from './growthbook';

export const isMobileAtom = atom(false);

/**
 * Layout.Page's rail widths in px, one per rail size, so pages of a size share
 * a width (and dragging News never widens Workstreams). Clamped at render time.
 */
export const railWidthAtoms: Record<DsysRailSize, ReturnType<typeof atomWithStorage<number>>> = {
  // The original key, so widths saved before sizes existed carry over.
  nav: atomWithStorage<number>('layout:railWidth', DSYS_RAIL_DEFAULT_WIDTH.nav),
  feed: atomWithStorage<number>('layout:railWidth:feed', DSYS_RAIL_DEFAULT_WIDTH.feed),
};

// Theme atom that's derived from the theme preference.
export const derivedThemeAtom = atom((get) => {
  const preference = get(themePreferenceAtom);
  if (preference !== 'auto') {
    return preference;
  }

  const isDarkMode = get(darkModeAtom);
  return isDarkMode ? 'dark' : 'bright';
});
